<template>
  <div>
    <div v-if="item.text != null" class="popup-info__area section">
      <formatted-text :value="item.text" />
    </div>
  </div>
</template>

<script setup lang="ts">
import FormattedText from "@core/ui/FormattedText.vue";

defineProps<{
  item: {
    text?: string;
  };
}>();
</script>
